import { useParams, useSearchParams } from "react-router-dom";
import { X } from "lucide-react";
import { useProducts, useCategories, CATEGORY_NAMES } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { Skeleton } from "../components/ui/skeleton";

const ComingSoon = () => (
  <div data-testid="coming-soon-card" className="flex aspect-[4/5] flex-col justify-end rounded-md border border-dashed border-border bg-card p-8">
    <p className="eyebrow">Coming soon</p>
    <p className="mt-3 font-display text-2xl">More pieces for the same system.</p>
    <p className="mt-3 text-sm text-muted-foreground">Add-ons that fit the Pustak Rack, built the same way: flat-packed, DIY, made for Hyderabad homes.</p>
  </div>
);

export default function Shop() {
  const { category } = useParams();
  const [sp, setSp] = useSearchParams();
  const q = sp.get("q") || "";
  const { data: cats = [] } = useCategories();
  const params = {};
  if (category) params.category = category;
  if (q) params.q = q;
  const { data = [], isLoading } = useProducts(params);
  const blurb = cats.find((c) => c.slug === category)?.blurb;

  return (
    <div className="container-hw py-12 lg:py-16">
      <p className="eyebrow">Shop</p>
      <h1 data-testid="shop-title" className="mt-3 text-4xl sm:text-5xl">{category ? CATEGORY_NAMES[category] : "DIY modular furniture"}</h1>
      <p className="mt-4 max-w-xl text-muted-foreground">{blurb || "Flat-packed, built at home by you, and delivered free across Hyderabad in 1 to 2 days."}</p>
      <div className="mt-10">
        {q && (
          <p data-testid="shop-result-count" className="mb-8 text-sm text-muted-foreground">
            {isLoading ? "Searching" : `${data.length} ${data.length === 1 ? "piece" : "pieces"}`}
            <button data-testid="clear-search-button" onClick={() => setSp({})} className="chip ml-3">for "{q}" <X className="h-3 w-3" /></button>
          </p>
        )}
        {isLoading ? (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">{[...Array(3)].map((_, i) => <Skeleton key={i} className="aspect-[4/5]" />)}</div>
        ) : data.length === 0 ? (
          <div data-testid="shop-empty" className="rounded-md border border-dashed border-border p-12 text-center">
            <p className="font-display text-2xl">Nothing matches that yet.</p>
            <button onClick={() => setSp({})} data-testid="reset-filters-button" className="btn-outline mt-6">See everything</button>
          </div>
        ) : (
          <div data-testid="product-grid" className="grid gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
            {data.map((p) => <ProductCard key={p.slug} product={p} />)}
            <ComingSoon />
          </div>
        )}
      </div>
    </div>
  );
}
